import React, { useState } from "react";
import { withStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import EditIcon from "@mui/icons-material/Edit";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import EditMetersDialog from "./EditMetersDialog";
import Tooltip from "@mui/material/Tooltip";
import Button from "components/CustomButtons/Button.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

export default function EditMeters({ refetch, meters, disabled, energy, parameters }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Tooltip title="Modifier la sélection">
        <Button
          onClick={handleClickOpen}
          color={"warning"}
          className={classes.actionButton}
          disabled={disabled}
        >
          <EditIcon fontSize="large" />
        </Button>
      </Tooltip>
      <Dialog
        onClose={handleClose}
        aria-labelledby="addMarket-dialog-title"
        //fullWidth={true}
        maxWidth="sm"
        open={open}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose}>
          Modifier la sélection
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditMetersDialog closeModal={handleClose} refetch={refetch} meters={meters} energy={energy} parameters={parameters} />
        </DialogContent>
        <DialogActions />
      </Dialog>
    </div>
  );
}
